module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "0"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("商品管理")])]), _vm._v(" "), _c('div', [_c('el-button', {
    staticClass: "m-1",
    staticStyle: {
      "margin-bottom": "2%",
      "margin-top": "2%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.append()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增")]), _vm._v(" "), _c('el-select', {
    staticClass: "m-1",
    staticStyle: {
      "margin-left": "5%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getProduct
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  }, [_c('el-option', {
    key: "全部",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: "激活",
    attrs: {
      "label": "激活",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "停用",
    attrs: {
      "label": "停用",
      "value": "0"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticClass: "input-with-select m-1",
    staticStyle: {
      "width": "50%",
      "margin-left": "5%"
    },
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getProduct
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.items.slice((_vm.page - 1) * 10, _vm.page * 10),
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "SKU",
      "label": "SKU"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "商品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "avatar",
          staticStyle: {
            "height": "30px"
          },
          attrs: {
            "src": scope.row.商品图片
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "productName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "price",
      "label": "售价",
      "formatter": _vm.formatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.prostatus == '1' ? '激活' : '停用') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "background-color": "#43c291",
            "color": "#fff"
          },
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.prostatus == '1') ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.remove(scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (scope.row.prostatus == '0') ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.recovery(scope.row)
            }
          }
        }, [_vm._v("恢复")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 10),
      expression: "items.length>10"
    }],
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next , jumper",
      "current-page": _vm.page,
      "background": "",
      "total": _vm.items.length
    },
    on: {
      "current-change": _vm.table
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2069061c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/product/pro.vue
// module id = 1040
// module chunks = 2